module.exports = __webpack_public_path__ + "static/media/marigolds.7546fefb.png";